import { render, staticRenderFns } from "./SalesRefund.vue?vue&type=template&id=3c660a89&scoped=true&"
import script from "./SalesRefund.vue?vue&type=script&lang=js&"
export * from "./SalesRefund.vue?vue&type=script&lang=js&"
import style0 from "./SalesRefund.vue?vue&type=style&index=0&id=3c660a89&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c660a89",
  null
  
)

export default component.exports